import Action from '../constants/services_form';
import Dispatcher from '../dispatcher';

const showServicesLightbox = (payload) => Dispatcher.handleServicesFormAction({
    type: Action.SHOW_ACTION,
    payload
});

const hideServicesLightbox = () => Dispatcher.handleServicesFormAction({
    type: Action.HIDE_ACTION
});

const setFormStep = (payload) => Dispatcher.handleServicesFormAction({
    type: Action.SET_SERVICE_FORM_STEP,
    payload
});

export {
    showServicesLightbox,
    hideServicesLightbox,
    setFormStep
};